export const VISUAL_STYLE_VALUES = ["realistic", "cinematic", "animation_3d", "anime", "comic", "watercolor", "noir"];
export const VisualStyle = {
    REALISTIC: "realistic",
    CINEMATIC: "cinematic",
    ANIMATION_3D: "animation_3d",
    ANIME: "anime",
    COMIC: "comic",
    WATERCOLOR: "watercolor",
    NOIR: "noir",
};
export const VISUAL_STYLE_LABELS = {
    [VisualStyle.REALISTIC]: "Réaliste (photo)",
    [VisualStyle.CINEMATIC]: "Cinématographique",
    [VisualStyle.ANIMATION_3D]: "Animation 3D",
    [VisualStyle.ANIME]: "Animé / manga",
    [VisualStyle.COMIC]: "Bande dessinée",
    [VisualStyle.WATERCOLOR]: "Aquarelle",
    [VisualStyle.NOIR]: "Noir & blanc contrasté",
};
export const VISUAL_STYLE_PROMPTS = {
    [VisualStyle.REALISTIC]: "photorealistic, natural lighting, shot on a full-frame camera, high detail",
    [VisualStyle.CINEMATIC]: "cinematic film still, dramatic lighting, shallow depth of field, anamorphic look, color graded",
    [VisualStyle.ANIMATION_3D]: "3D animation style, stylized characters, soft global illumination, high-end animated feature film look",
    [VisualStyle.ANIME]: "anime style, clean line art, cel shading, expressive characters, detailed background art",
    [VisualStyle.COMIC]: "comic book illustration, bold ink outlines, flat colors, dynamic composition",
    [VisualStyle.WATERCOLOR]: "watercolor painting, soft washes, visible paper texture, delicate brush strokes",
    [VisualStyle.NOIR]: "black and white film noir, hard shadows, high contrast, moody atmosphere",
};
